import { render, staticRenderFns } from "./MultiBarchart.vue?vue&type=template&id=54fbe4ca&"
import script from "./MultiBarchart.vue?vue&type=script&lang=js&"
export * from "./MultiBarchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports